<template>
  <GlobalDialog
    :titleCenter="false"
    dialogDefaultSize="70%"
    v-model="showDialog"
    title=""
    :showClose="false"
    :showActionButton="false"
    forceClose
  >
    <template #content>
      <div
        class="relative text-left overflow-hidden transform transition-all w-full"
      >
        <div
          class="flex items-start justify-between gap-4 pb-4 border-b border-untitled-gray-100"
        >
          <div class="flex items-start gap-3">
            <div
              class="flex items-center justify-center w-12 h-12 rounded-xl bg-app-primary/10 text-app-primary shrink-0"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke-width="1.5"
                stroke="currentColor"
                class="w-6 h-6"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M9 12h3.75M9 15h3.75M9 18h3.75M3.75 6.75h16.5M3.75 6.75c0-1.036.84-1.875 1.875-1.875h13.5c1.035 0 1.875.84 1.875 1.875M3.75 6.75v10.5c0 1.035.84 1.875 1.875 1.875h13.5c1.035 0 1.875-.84 1.875-1.875V6.75M16.5 3v3.75m-9-3.75v3.75"
                />
              </svg>
            </div>
            <div>
              <h3 class="text-base font-semibold text-untitled-gray-900">
                Assigned to You
              </h3>
              <p class="text-sm text-untitled-gray-500 mt-0.5">
                Units, modules, courses, and playlists your admin has
                assigned to you.
              </p>
            </div>
          </div>
          <button
            type="button"
            @click="showDialog = false"
            class="shrink-0 text-untitled-gray-400 hover:text-untitled-gray-600 transition-colors"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke-width="1.5"
              stroke="currentColor"
              class="w-6 h-6"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        </div>

        <div
          class="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 py-4 border-b border-untitled-gray-100"
        >
          <p class="text-sm text-untitled-gray-500">
            <span class="font-semibold text-untitled-gray-700">{{
              filteredUnitsList.length +
              filteredModuleList.length +
              filteredCourseList.length +
              playlists.length
            }}</span>
            item<span
              v-if="
                filteredUnitsList.length +
                  filteredModuleList.length +
                  filteredCourseList.length +
                  playlists.length !==
                1
              "
              >s</span
            >
            assigned
          </p>
          <div class="flex items-center gap-2 w-full sm:w-auto">
            <label
              class="text-xs font-medium text-untitled-gray-500 whitespace-nowrap"
              >Sort by</label
            >
            <div class="w-full sm:w-[190px]">
              <ECombobox
                v-model="sortBy"
                name="sorts"
                :options="sorts"
                option-name="name"
                value-key="value"
                placeholder="Sort By"
                :multiple="false"
                :filterable="false"
                :clearable="false"
              />
            </div>
          </div>
        </div>

        <div class="pt-4">
          <div class="w-full">
            <ul
              class="flex list-none flex-wrap gap-1 py-1 mb-3 flex-row bg-untitled-gray-100 rounded-lg p-1 w-full"
            >
              <li
                v-for="toggle in toggles"
                :key="toggle.id"
                class="flex-auto text-center"
              >
                <a
                  class="flex items-center justify-center gap-1.5 text-xs font-semibold px-4 py-2 rounded-md leading-normal cursor-pointer transition-colors"
                  v-on:click="toggleTabs(toggle.id)"
                  :class="{
                    'text-untitled-gray-500 hover:text-untitled-gray-700':
                      openTab !== toggle.id,
                    'text-app-primary bg-white shadow-sm':
                      openTab === toggle.id,
                  }"
                >
                  {{ toggle.name }}
                  <span v-if="toggle.count >= 0" class="text-untitled-gray-400"
                    >({{ toggle.count }})</span
                  >
                </a>
              </li>
            </ul>
            <div
              class="relative flex flex-col min-w-0 break-words bg-white w-full z-0"
            >
              <div class="flex-auto">
                <div class="tab-content tab-space">
                  <div
                    :class="{
                      hidden: openTab !== 1,
                      block: openTab === 1,
                    }"
                  >
                    <LoadingState
                      v-if="loadingUnits"
                      class="mx-auto text-center py-12"
                    />
                    <div v-else>
                      <Suspense>
                        <ul
                          v-if="filteredUnitsList.length > 0"
                          role="list"
                          class="grid lg:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4 md:grid-cols-1 grid-cols-1 gap-4 py-4 pr-1"
                        >
                          <li
                            class="flex flex-col rounded-lg border border-untitled-gray-200 bg-white overflow-hidden hover:border-untitled-gray-300 hover:shadow-md transition-all"
                            v-for="data in filteredUnitsList"
                            :key="data.unit?.id"
                          >
                            <div class="flex-shrink-0">
                              <img
                                v-if="data.thumbnail?.includes('google')"
                                class="w-full h-40 object-cover"
                                v-lazy="{
                                  src: 'https://lms-v2-staging.s3-us-west-2.amazonaws.com/modules/default-thumbnail.jpg',
                                  error:
                                    'https://lms-v2-staging.s3-us-west-2.amazonaws.com/modules/default-thumbnail.jpg',
                                  loading:
                                    'https://via.placeholder.com/800x450?text=Thumbnail%20Loading...',
                                }"
                              />
                              <img
                                v-else-if="data?.thumbnail"
                                v-lazy="{
                                  src: data?.thumbnail,
                                  error:
                                    'https://lms-v2-staging.s3-us-west-2.amazonaws.com/modules/default-thumbnail.jpg',
                                  loading:
                                    'https://via.placeholder.com/800x450?text=Thumbnail%20Loading...',
                                }"
                                class="w-full h-40 object-cover"
                              />
                            </div>

                            <div class="flex flex-col flex-1 p-4 gap-3">
                              <div class="flex items-start justify-between gap-2">
                                <h4
                                  class="text-sm font-semibold text-untitled-gray-800 leading-snug"
                                >
                                  <a
                                    href="#"
                                    class="hover:text-app-primary transition-colors"
                                    >{{ data.unit?.name }}</a
                                  >
                                </h4>
                                <span
                                  class="shrink-0 inline-flex items-center gap-1 text-[11px] font-semibold uppercase tracking-wide px-2 py-0.5 rounded-full bg-untitled-gray-50"
                                  :class="getStatusColor(data.status)"
                                >
                                  <span
                                    class="w-1.5 h-1.5 rounded-full bg-current"
                                  ></span>
                                  {{ data.status }}
                                </span>
                              </div>

                              <div
                                class="grid grid-cols-2 gap-x-3 gap-y-1.5 text-xs text-untitled-gray-400"
                              >
                                <div v-if="data.assigned_by">
                                  Assignor
                                  <p class="font-medium text-untitled-gray-700">
                                    {{ data.assigned_by }}
                                  </p>
                                </div>
                                <div v-if="data.assigned_at">
                                  Assigned Date
                                  <p class="font-medium text-untitled-gray-700">
                                    {{ data.assigned_at }}
                                  </p>
                                </div>
                                <div v-if="data.start_date">
                                  Start Date
                                  <p class="font-medium text-untitled-gray-700">
                                    {{ data.start_date }}
                                  </p>
                                </div>
                                <div v-if="data.due_date">
                                  End Date
                                  <p class="font-medium text-untitled-gray-700">
                                    {{ data.due_date }}
                                  </p>
                                </div>
                              </div>

                              <div
                                class="mt-auto pt-3 border-t border-untitled-gray-100"
                              >
                                <button
                                  @click="goToUnitScorm(data.unit)"
                                  type="button"
                                  class="inline-flex items-center gap-1.5 px-3 py-1.5 text-xs font-semibold rounded-md text-white bg-app-primary hover:bg-app-secondary transition-colors"
                                >
                                  <svg
                                    v-if="data.is_stream"
                                    xmlns="http://www.w3.org/2000/svg"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                    stroke-width="1.5"
                                    stroke="currentColor"
                                    class="w-3 h-3"
                                  >
                                    <path
                                      stroke-linecap="round"
                                      stroke-linejoin="round"
                                      d="M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25m2.25 0H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9z"
                                    />
                                  </svg>

                                  <svg
                                    v-else
                                    xmlns="http://www.w3.org/2000/svg"
                                    fill="none"
                                    viewBox="0 0 24 24"
                                    stroke-width="1.5"
                                    stroke="currentColor"
                                    class="w-3 h-3"
                                  >
                                    <path
                                      stroke-linecap="round"
                                      d="M15.75 10.5l4.72-4.72a.75.75 0 011.28.53v11.38a.75.75 0 01-1.28.53l-4.72-4.72M4.5 18.75h9a2.25 2.25 0 002.25-2.25v-9a2.25 2.25 0 00-2.25-2.25h-9A2.25 2.25 0 002.25 7.5v9a2.25 2.25 0 002.25 2.25z"
                                    />
                                  </svg>
                                  Open Unit
                                </button>
                              </div>
                            </div>
                          </li>
                        </ul>
                        <div
                          v-else
                          class="flex flex-col items-center justify-center py-12 text-untitled-gray-400"
                        >
                          <svg
                            viewBox="0 0 24 24"
                            fill="none"
                            stroke="currentColor"
                            stroke-width="1.5"
                            class="w-10 h-10"
                          >
                            <path
                              stroke-linecap="round"
                              stroke-linejoin="round"
                              d="M9 12h3.75M9 15h3.75M9 18h3.75M3.75 6.75h16.5M3.75 6.75c0-1.036.84-1.875 1.875-1.875h13.5c1.035 0 1.875.84 1.875 1.875M3.75 6.75v10.5c0 1.035.84 1.875 1.875 1.875h13.5c1.035 0 1.875-.84 1.875-1.875V6.75M16.5 3v3.75m-9-3.75v3.75"
                            />
                          </svg>
                          <p class="mt-3 text-sm font-medium text-untitled-gray-500">
                            No units found.
                          </p>
                        </div>
                      </Suspense>
                    </div>
                  </div>
                  <div
                    :class="{
                      hidden: openTab !== 2,
                      block: openTab === 2,
                    }"
                  >
                    <LoadingState
                      v-if="loadingModules"
                      class="mx-auto text-center py-12"
                    />
                    <div v-else>
                      <ul
                        v-if="filteredModuleList.length > 0"
                        role="list"
                        class="grid lg:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4 md:grid-cols-1 grid-cols-1 gap-4 py-4 pr-1"
                      >
                        <li
                          class="flex flex-col rounded-lg border border-untitled-gray-200 bg-white overflow-hidden hover:border-untitled-gray-300 hover:shadow-md transition-all"
                          v-for="data in filteredModuleList"
                          :key="data.id"
                        >
                          <div class="flex-shrink-0">
                            <img
                              v-if="
                                data.availableThumbnail &&
                                !data.thumbnail?.includes('vimeo')
                              "
                              v-lazy="{
                                src: data.thumbnail,
                                error:
                                  'https://lms-v2-staging.s3-us-west-2.amazonaws.com/modules/default-thumbnail.jpg',
                                loading:
                                  'https://via.placeholder.com/800x450?text=Thumbnail%20Loading...',
                              }"
                              class="w-full h-40 object-cover"
                            />
                            <iframe
                              v-else-if="data.thumbnail?.includes('vimeo')"
                              title=""
                              id="votd-vimeo"
                              class="w-full h-40"
                              webkitallowfullscreen
                              mozallowfullscreen
                              allowfullscreen
                              :src="data.thumbnail"
                            ></iframe>
                            <img
                              v-else
                              src="https://lms-v2-staging.s3-us-west-2.amazonaws.com/modules/default-thumbnail.jpg"
                              class="w-full h-40 object-cover"
                            />
                          </div>

                          <div class="flex flex-col flex-1 p-4 gap-3">
                            <div class="flex items-start justify-between gap-2">
                              <h4
                                class="text-sm font-semibold text-untitled-gray-800 leading-snug"
                              >
                                <a
                                  href="#"
                                  class="hover:text-app-primary transition-colors"
                                  >{{ data.name }}</a
                                >
                              </h4>
                              <span
                                class="shrink-0 inline-flex items-center gap-1 text-[11px] font-semibold uppercase tracking-wide px-2 py-0.5 rounded-full bg-untitled-gray-50"
                                :class="getStatusColor(data.status)"
                              >
                                <span
                                  class="w-1.5 h-1.5 rounded-full bg-current"
                                ></span>
                                {{ data.status }}
                              </span>
                            </div>

                            <div>
                              <div
                                class="flex items-center justify-between text-xs text-untitled-gray-500 mb-1"
                              >
                                <span>Progress</span>
                                <span class="font-medium text-untitled-gray-700"
                                  >{{ data.total_units_completed }}/{{
                                    data.total_units
                                  }}
                                  Units</span
                                >
                              </div>
                              <div
                                class="w-full h-1.5 bg-untitled-gray-100 rounded-full overflow-hidden"
                              >
                                <div
                                  class="h-full bg-app-primary rounded-full"
                                  :style="{
                                    width:
                                      (data.total_units
                                        ? (data.total_units_completed /
                                            data.total_units) *
                                          100
                                        : 0) + '%',
                                  }"
                                ></div>
                              </div>
                            </div>

                            <div
                              class="grid grid-cols-2 gap-x-3 gap-y-1.5 text-xs text-untitled-gray-400"
                            >
                              <div v-if="data.assigned_by">
                                Assignor
                                <p class="font-medium text-untitled-gray-700">
                                  {{ data.assigned_by }}
                                </p>
                              </div>
                              <div v-if="data.assigned_at">
                                Assigned Date
                                <p class="font-medium text-untitled-gray-700">
                                  {{ data.assigned_at }}
                                </p>
                              </div>
                              <div v-if="data.start_date">
                                Start Date
                                <p class="font-medium text-untitled-gray-700">
                                  {{ data.start_date }}
                                </p>
                              </div>
                              <div v-if="data.due_date">
                                End Date
                                <p class="font-medium text-untitled-gray-700">
                                  {{ data.due_date }}
                                </p>
                              </div>
                            </div>

                            <div
                              class="mt-auto pt-3 border-t border-untitled-gray-100"
                            >
                              <button
                                @click="gotoUnit(data.first_unit_id)"
                                type="button"
                                class="inline-flex items-center gap-1.5 px-3 py-1.5 text-xs font-semibold rounded-md text-white bg-app-primary hover:bg-app-secondary transition-colors"
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  fill="none"
                                  viewBox="0 0 24 24"
                                  stroke-width="1.5"
                                  stroke="currentColor"
                                  class="w-3 h-3"
                                >
                                  <path
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    d="M13.5 6H5.25A2.25 2.25 0 003 8.25v10.5A2.25 2.25 0 005.25 21h10.5A2.25 2.25 0 0018 18.75V10.5m-10.5 6L21 3m0 0h-5.25M21 3v5.25"
                                  />
                                </svg>
                                Open Module
                              </button>
                            </div>
                          </div>
                        </li>
                      </ul>
                      <div
                        v-else
                        class="flex flex-col items-center justify-center py-12 text-untitled-gray-400"
                      >
                        <svg
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          stroke-width="1.5"
                          class="w-10 h-10"
                        >
                          <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            d="M3 7l2-4h14l2 4M3 7v11a2 2 0 002 2h14a2 2 0 002-2V7M3 7h18M9 11h6"
                          />
                        </svg>
                        <p class="mt-3 text-sm font-medium text-untitled-gray-500">
                          No modules found.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div
                    :class="{
                      hidden: openTab !== 3,
                      block: openTab === 3,
                    }"
                  >
                    <LoadingState
                      v-if="loadingCourses"
                      class="mx-auto text-center py-12"
                    />
                    <div v-else>
                      <ul
                        v-if="filteredCourseList.length > 0"
                        role="list"
                        class="grid lg:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4 md:grid-cols-1 grid-cols-1 gap-4 py-4 pr-1"
                      >
                        <li
                          class="flex flex-col rounded-lg border border-untitled-gray-200 bg-white overflow-hidden hover:border-untitled-gray-300 hover:shadow-md transition-all"
                          v-for="assigned_course in filteredCourseList"
                          :key="assigned_course.course_id"
                        >
                          <div class="flex-shrink-0">
                            <img
                              v-if="assigned_course.thumbnail"
                              class="w-full h-40 object-cover"
                              v-lazy="{
                                src: assigned_course.thumbnail,
                                error:
                                  'https://lms-v2-staging.s3-us-west-2.amazonaws.com/modules/default-thumbnail.jpg',
                                loading:
                                  'https://via.placeholder.com/800x450?text=Thumbnail%20Loading...',
                              }"
                            />
                            <img
                              v-else
                              src="https://lms-v2-staging.s3-us-west-2.amazonaws.com/modules/default-thumbnail.jpg"
                              class="w-full h-40 object-cover"
                            />
                          </div>

                          <div class="flex flex-col flex-1 p-4 gap-3">
                            <div class="flex items-start justify-between gap-2">
                              <h4
                                class="text-sm font-semibold text-untitled-gray-800 leading-snug"
                              >
                                <a
                                  href="#"
                                  class="hover:text-app-primary transition-colors"
                                  >{{ assigned_course.name }}</a
                                >
                              </h4>
                              <span
                                class="shrink-0 inline-flex items-center gap-1 text-[11px] font-semibold uppercase tracking-wide px-2 py-0.5 rounded-full bg-untitled-gray-50"
                                :class="getStatusColor(assigned_course.status)"
                              >
                                <span
                                  class="w-1.5 h-1.5 rounded-full bg-current"
                                ></span>
                                {{ assigned_course.status }}
                              </span>
                            </div>

                            <div>
                              <div
                                class="flex items-center justify-between text-xs text-untitled-gray-500 mb-1"
                              >
                                <span>Progress</span>
                                <span class="font-medium text-untitled-gray-700"
                                  >{{ assigned_course.total_units_completed }}/{{
                                    assigned_course.total_units
                                  }}
                                  Units</span
                                >
                              </div>
                              <div
                                class="w-full h-1.5 bg-untitled-gray-100 rounded-full overflow-hidden"
                              >
                                <div
                                  class="h-full bg-app-primary rounded-full"
                                  :style="{
                                    width:
                                      (assigned_course.total_units
                                        ? (assigned_course.total_units_completed /
                                            assigned_course.total_units) *
                                          100
                                        : 0) + '%',
                                  }"
                                ></div>
                              </div>
                            </div>

                            <div
                              class="grid grid-cols-2 gap-x-3 gap-y-1.5 text-xs text-untitled-gray-400"
                            >
                              <div v-if="assigned_course.assigned_by">
                                Assignor
                                <p class="font-medium text-untitled-gray-700">
                                  {{ assigned_course.assigned_by }}
                                </p>
                              </div>
                              <div v-if="assigned_course.assigned_at">
                                Assigned Date
                                <p class="font-medium text-untitled-gray-700">
                                  {{ assigned_course.assigned_at }}
                                </p>
                              </div>
                              <div v-if="assigned_course.start_date">
                                Start Date
                                <p class="font-medium text-untitled-gray-700">
                                  {{ assigned_course.start_date }}
                                </p>
                              </div>
                              <div v-if="assigned_course.due_date">
                                End Date
                                <p class="font-medium text-untitled-gray-700">
                                  {{ assigned_course.due_date }}
                                </p>
                              </div>
                            </div>

                            <div
                              class="mt-auto pt-3 border-t border-untitled-gray-100"
                            >
                              <button
                                @click="gotoUnit(assigned_course.first_unit_id)"
                                type="button"
                                class="inline-flex items-center gap-1.5 px-3 py-1.5 text-xs font-semibold rounded-md text-white bg-app-primary hover:bg-app-secondary transition-colors"
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  fill="none"
                                  viewBox="0 0 24 24"
                                  stroke-width="1.5"
                                  stroke="currentColor"
                                  class="w-3 h-3"
                                >
                                  <path
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    d="M13.5 6H5.25A2.25 2.25 0 003 8.25v10.5A2.25 2.25 0 005.25 21h10.5A2.25 2.25 0 0018 18.75V10.5m-10.5 6L21 3m0 0h-5.25M21 3v5.25"
                                  />
                                </svg>
                                Open Course
                              </button>
                            </div>
                          </div>
                        </li>
                      </ul>
                      <div
                        v-else
                        class="flex flex-col items-center justify-center py-12 text-untitled-gray-400"
                      >
                        <svg
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          stroke-width="1.5"
                          class="w-10 h-10"
                        >
                          <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            d="M4.26 10.147a60.436 60.436 0 00-.491 6.347A48.62 48.62 0 0112 20.904a48.62 48.62 0 018.232-4.41 60.46 60.46 0 00-.491-6.347m-15.482 0a50.636 50.636 0 00-2.658-.813A59.906 59.906 0 0112 3.493a59.903 59.903 0 0110.399 5.84c-.896.248-1.783.52-2.658.814m-15.482 0A50.717 50.717 0 0112 13.489a50.702 50.702 0 017.74-3.342M6.75 15a.75.75 0 100-1.5.75.75 0 000 1.5zm0 0v-3.675A55.378 55.378 0 0112 8.443m-7.007 11.55A5.981 5.981 0 006.75 15.75v-1.5"
                          />
                        </svg>
                        <p class="mt-3 text-sm font-medium text-untitled-gray-500">
                          No courses assigned to you.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div
                    :class="{
                      hidden: openTab !== 4,
                      block: openTab === 4,
                    }"
                  >
                    <LoadingState
                      v-if="loadingPlaylist"
                      class="mx-auto text-center py-12"
                    />
                    <div v-else>
                      <ul
                        v-if="playlists.length > 0"
                        role="list"
                        class="grid lg:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4 md:grid-cols-1 grid-cols-1 gap-4 py-4 pr-1"
                      >
                        <li
                          class="flex flex-col rounded-lg border border-untitled-gray-200 bg-white overflow-hidden hover:border-untitled-gray-300 hover:shadow-md transition-all"
                          v-for="assigned_playlist in playlists"
                          :key="assigned_playlist.playlist_id"
                        >
                          <div class="flex-shrink-0" v-if="assigned_playlist.thumbnail">
                            <img
                              v-if="
                                assigned_playlist?.thumbnail?.includes('google')
                              "
                              v-lazy="{
                                src: 'https://lms-v2-staging.s3-us-west-2.amazonaws.com/modules/default-thumbnail.jpg',
                                error:
                                  'https://lms-v2-staging.s3-us-west-2.amazonaws.com/modules/default-thumbnail.jpg',
                                loading:
                                  'https://via.placeholder.com/800x450?text=Thumbnail%20Loading...',
                              }"
                              class="w-full h-40 object-cover"
                            />
                            <img
                              v-else-if="assigned_playlist.thumbnail"
                              class="w-full h-40 object-cover"
                              v-lazy="{
                                src: assigned_playlist.thumbnail,
                                error:
                                  'https://lms-v2-staging.s3-us-west-2.amazonaws.com/modules/default-thumbnail.jpg',
                                loading:
                                  'https://via.placeholder.com/800x450?text=Thumbnail%20Loading...',
                              }"
                            />
                            <img
                              v-else
                              src="https://lms-v2-staging.s3-us-west-2.amazonaws.com/modules/default-thumbnail.jpg"
                              class="w-full h-40 object-cover"
                            />
                          </div>

                          <div class="flex flex-col flex-1 p-4 gap-3">
                            <div class="flex items-start justify-between gap-2">
                              <h4
                                class="text-sm font-semibold text-untitled-gray-800 leading-snug"
                              >
                                <a
                                  href="#"
                                  class="hover:text-app-primary transition-colors"
                                  >{{ assigned_playlist.name }}</a
                                >
                              </h4>
                              <span
                                class="shrink-0 inline-flex items-center gap-1 text-[11px] font-semibold uppercase tracking-wide px-2 py-0.5 rounded-full bg-untitled-gray-50"
                                :class="getStatusColor(assigned_playlist.status)"
                              >
                                <span
                                  class="w-1.5 h-1.5 rounded-full bg-current"
                                ></span>
                                {{ assigned_playlist.status }}
                              </span>
                            </div>

                            <div>
                              <div
                                class="flex items-center justify-between text-xs text-untitled-gray-500 mb-1"
                              >
                                <span>Progress</span>
                                <span class="font-medium text-untitled-gray-700"
                                  >{{
                                    assigned_playlist.total_units_completed
                                  }}/{{ assigned_playlist.total_units }}
                                  Units</span
                                >
                              </div>
                              <div
                                class="w-full h-1.5 bg-untitled-gray-100 rounded-full overflow-hidden"
                              >
                                <div
                                  class="h-full bg-app-primary rounded-full"
                                  :style="{
                                    width:
                                      (assigned_playlist.total_units
                                        ? (assigned_playlist.total_units_completed /
                                            assigned_playlist.total_units) *
                                          100
                                        : 0) + '%',
                                  }"
                                ></div>
                              </div>
                            </div>

                            <div
                              class="grid grid-cols-2 gap-x-3 gap-y-1.5 text-xs text-untitled-gray-400"
                            >
                              <div v-if="assigned_playlist.assigned_by">
                                Assignor
                                <p class="font-medium text-untitled-gray-700">
                                  {{ assigned_playlist.assigned_by }}
                                </p>
                              </div>
                              <div v-if="assigned_playlist.assigned_at">
                                Assigned Date
                                <p class="font-medium text-untitled-gray-700">
                                  {{ assigned_playlist.assigned_at }}
                                </p>
                              </div>
                              <div v-if="assigned_playlist.start_date">
                                Start Date
                                <p class="font-medium text-untitled-gray-700">
                                  {{ assigned_playlist.start_date }}
                                </p>
                              </div>
                              <div v-if="assigned_playlist.due_date">
                                End Date
                                <p class="font-medium text-untitled-gray-700">
                                  {{ assigned_playlist.due_date }}
                                </p>
                              </div>
                            </div>

                            <div
                              class="mt-auto pt-3 border-t border-untitled-gray-100"
                            >
                              <button
                                @click="
                                  gotoUnit(
                                    assigned_playlist.first_unit_id,
                                    assigned_playlist.playlist_id,
                                    assigned_playlist.type
                                  )
                                "
                                type="button"
                                class="inline-flex items-center gap-1.5 px-3 py-1.5 text-xs font-semibold rounded-md text-white bg-app-primary hover:bg-app-secondary transition-colors"
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  fill="none"
                                  viewBox="0 0 24 24"
                                  stroke-width="1.5"
                                  stroke="currentColor"
                                  class="w-3 h-3"
                                >
                                  <path
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    d="M13.5 6H5.25A2.25 2.25 0 003 8.25v10.5A2.25 2.25 0 005.25 21h10.5A2.25 2.25 0 0018 18.75V10.5m-10.5 6L21 3m0 0h-5.25M21 3v5.25"
                                  />
                                </svg>
                                Open Playlist
                              </button>
                            </div>
                          </div>
                        </li>
                      </ul>

                      <div
                        v-else
                        class="flex flex-col items-center justify-center py-12 text-untitled-gray-400"
                      >
                        <svg
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          stroke-width="1.5"
                          class="w-10 h-10"
                        >
                          <path
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            d="M15.75 10.5l4.72-4.72a.75.75 0 011.28.53v11.38a.75.75 0 01-1.28.53l-4.72-4.72M4.5 18.75h9a2.25 2.25 0 002.25-2.25v-9a2.25 2.25 0 00-2.25-2.25h-9A2.25 2.25 0 002.25 7.5v9a2.25 2.25 0 002.25 2.25z"
                          />
                        </svg>
                        <p class="mt-3 text-sm font-medium text-untitled-gray-500">
                          No playlist assigned to you.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </GlobalDialog>
</template>

<script setup>
import {
  ref,
  computed,
  defineEmits,
  inject,
  watch,
  defineProps,
  onMounted,
} from "vue";
import LoadingState from "@/components/partials/LoadingState";
import { useRouter } from "vue-router";
import Bugsnag from "@bugsnag/js";
import ECombobox from "@/components/element-components/ECombobox";
import GlobalDialog from "@/components/layout/GlobalDialog.vue";
import dayjs from "dayjs";

var localizedFormat = require("dayjs/plugin/localizedFormat");
dayjs.extend(localizedFormat);
import { getStatusColor } from "@/helpers/status_color";

const props = defineProps({
  modelValue: {
    type: Boolean,
    default: false,
    required: true,
  },
});
const openTab = ref(1);
const emit = defineEmits(["close", "update:modelValue"]);
const router = useRouter();
const axios = inject("axios");
const units = ref([]);
const modules = ref([]);
const courses = ref([]);
const playlists = ref([]);
const loadingUnits = ref(false);
const loadingModules = ref(false);
const loadingCourses = ref(false);
const loadingPlaylist = ref(false);
const assigned = ref({});
const sortBy = ref(null);
const showDialog = computed({
  get() {
    return props.modelValue;
  },
  set(newValue) {
    emit("update:modelValue", newValue);
  },
});
const sorts = ref([
  {
    name: "A-Z",
    value: "a-z",
  },
  {
    name: "Z-A",
    value: "z-a",
  },
  {
    name: "Newest to Oldest",
    value: "newest",
  },
  {
    name: "Oldest to Newest",
    value: "oldest",
  },
]);

function changeSort(sortBy) {
  switch (openTab.value) {
    case 1:
      sorting(filteredUnitsList.value, sortBy);
      break;
    case 2:
      sorting(filteredModuleList.value, sortBy);
      break;
    case 3:
      sorting(filteredCourseList.value, sortBy);
      break;
    case 4:
      sorting(playlists.value, sortBy);
  }
}

const sorting = (contents, sortBy) => {
  const sortData = ref(contents);
  sortData.value.sort((a, b) => {
    switch (sortBy) {
      case "a-z":
        if (openTab.value == 1) {
          return a.unit?.name.localeCompare(b.unit?.name);
        }
        return a.name.localeCompare(b.name);
      case "z-a":
        if (openTab.value == 1) {
          return b.unit?.name.localeCompare(a.unit?.name);
        }
        return b.name.localeCompare(a.name);
      case "newest":
        return new Date(b.assigned_at) - new Date(a.assigned_at);
      case "oldest":
        return new Date(a.assigned_at) - new Date(b.assigned_at);
    }
  });

  switch (openTab.value) {
    case 1:
      units.value = sortData.value;
      break;
    case 2:
      modules.value = sortData.value;
      break;
    case 3:
      courses.value = sortData.value;
      break;
    case 4:
      playlists.value = sortData.value;
  }
};

watch(sortBy, (val) => {
  changeSort(val);
});

const filteredCourseList = computed(() => {
  return courses.value ?? [];
});

const filteredModuleList = computed(() => {
  return modules.value ?? [];
});

const filteredUnitsList = computed(() => {
  return units.value ?? [];
});

const toggles = computed(() => {
  return [
    { id: 1, name: "Units", count: filteredUnitsList.value.length },
    { id: 2, name: "Modules", count: filteredModuleList.value.length },
    { id: 3, name: "Courses", count: filteredCourseList.value.length },
    { id: 4, name: "Playlist", count: playlists.value.length },
  ];
});

function toggleTabs(tab) {
  openTab.value = tab;
}

watch(openTab, () => {
  changeSort(sortBy.value);
});

function gotoUnit(unitId, playlistId = null, playlistType = "") {
  if (playlistId) {
    if (playlistType === "custom") {
      window.open(`/custom-playlist/${unitId}/${playlistId}`, "_blank");
    } else {
      window.open(`/units/${unitId}/${playlistId}`, "_blank");
    }
    return;
  }

  window.open(`/units/${unitId}`, "_blank");
}

function goToUnitScorm(unit) {
  if (unit.type === "scorm") {
    return router.push({
      name: "ScormCourseWatch",
      params: {
        id: unit.scorm_provider_id,
      },
    });
  }

  router.push(`/units/${unit.id}`);
}

const fetchAssignedContents = async () => {
  loadingUnits.value = true;
  await axios
    .get("/api/v3/user/my-progress/assigned-contents")
    .then((response) => {
      assigned.value = response.data;
      units.value = response.data.units;
      courses.value = response.data.courses;
      modules.value = response.data.modules;
      playlists.value = response.data.playlists;
      loadingUnits.value = false;
    })
    .catch((error) => {
      Bugsnag.notify(error);
    })
    .finally(() => {
      loadingUnits.value = false;
    });
};

onMounted(() => {
  fetchAssignedContents();
  changeSort("newest");
});

watch(showDialog, (value) => {
  if (value) {
    fetchAssignedContents();
    changeSort("newest");
  }
});
</script>
